import React from 'react';
import Iffy from '@alucio/lux-ui/src/components/util/Iffy/Iffy';
import DNABox from '@alucio/lux-ui/src/components/layout/DNABox/DNABox';
import DNAText from '@alucio/lux-ui/src/components/type/DNAText/DNAText';
import DNACard from '@alucio/lux-ui/src/components/layout/DNACard/DNACard';
import DNADivider from '@alucio/lux-ui/src/components/visual/DNADivider/DNADivider';
import DNAButton from '@alucio/lux-ui/src/components/controls/DNAButton/DNAButton';
// TODO: These styles should be dynamically set via a config prop when the modal is instantiated. E.g. if fullscreen then no padding, etc.
const S = {
    sectionPaddingHorizontal: {
        paddingHorizontal: 16,
    },
    sectionPaddingVertical: {
        paddingVertical: 16,
    },
    sectionPaddingBottom: {
        paddingBottom: 12,
    },
    sectionPaddingTop: {
        paddingTop: 12,
    },
};
export const DNAModal = (props) => {
    const { children, style, } = props;
    return (<DNACard appearance="float" style={style || S.sectionPaddingVertical}>
    <DNABox appearance="col" spacing={style ? undefined : 'medium'}>
      {children}
    </DNABox>
  </DNACard>);
};
export const DNAModalHeader = (props) => {
    const { onClose, style, children } = props;
    const headerContent = typeof children === 'string'
        ? <DNAText testID="dialog-title" h5>{children}</DNAText>
        : children;
    return (<>
      <DNABox spacing="between" alignY="center" style={style || ([S.sectionPaddingHorizontal, S.sectionPaddingBottom])}>
        {headerContent}
        <Iffy is={onClose}>
          <DNAButton appearance="ghost" status="neutral" context="minimum" iconLeft="close" onPress={onClose}/>
        </Iffy>
      </DNABox>
      <DNADivider />
    </>);
};
const DNAModalMessage = (props) => {
    const { children, style, status } = props;
    return (<DNABox style={style || S.sectionPaddingHorizontal} fill>
      
      <DNAText status={status}>
        {children}
      </DNAText>
    </DNABox>);
};
const DNAModalBody = (props) => {
    const { children, style } = props;
    return (<DNABox style={style || S.sectionPaddingHorizontal} fill>
      {children}
    </DNABox>);
};
const DNAModalFooter = (props) => {
    const { children } = props;
    return (<>
      <DNADivider />
      <DNABox style={[S.sectionPaddingHorizontal, S.sectionPaddingTop, { width: '100%' }]}>
        {children}
      </DNABox>
    </>);
};
const DNAModalConfirmation = (props) => {
    const { children, onCancel, onAction, actionStatus, actionLabel, style } = props;
    return (<>
      <DNADivider />
      <DNABox style={style || ([S.sectionPaddingHorizontal, S.sectionPaddingTop])} alignX="end" spacing="medium">
        <Iffy is={onCancel}>
          <DNAButton testID="cancel-button" size="small" status="subtle" onPress={onCancel}>
            Cancel
          </DNAButton>
        </Iffy>
        <Iffy is={onAction}>
          <DNAButton size="small" status={actionStatus ?? 'danger'} 
    // [TODO] Consider supporting async actions and render a spinner in the button
    onPress={onAction}>
            {actionLabel}
          </DNAButton>
        </Iffy>
        {children}
      </DNABox>
    </>);
};
DNAModal.displayName = 'DNAModal';
DNAModal.Header = DNAModalHeader;
DNAModal.Message = DNAModalMessage;
DNAModal.Body = DNAModalBody;
DNAModal.Confirmation = DNAModalConfirmation;
DNAModal.Footer = DNAModalFooter;
export default DNAModal;
//# sourceMappingURL=DNAModal.js.map